import { Component, Input, OnChanges, SimpleChanges, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { FormGroup, Validators, AbstractControl } from '@angular/forms';

import { DynamicField } from '../dynamic-field.class';
import { Subscription } from 'rxjs';
import { BaseWidgetComponent } from '../../../../shared/base.component';

@Component({
    selector: 'dynamic-field',
    template: `<div
    class="dynamic-field"
    widget
    [formGroup]="form"
    *ngIf="field && !field.hide && (field.control_type !== 'custom' || field.cmp)"
    [class.disabled]="field.disabled"
>
    <div
        [class]="'field ' + field.control_type + ' ' + field.key"
        [class.error]="(errors && dirty)"
    >
        <div class="icon" *ngIf="field.icon">
            <i
                *ngIf="field.icon.type === 'icon' || field.icon.class"
                [class]="field.icon.class"
                >{{field.icon?.value}}</i
            >
            <img
                *ngIf="field.icon.type !== 'icon' && !field.icon.class"
                [src]="field.icon.src"
            />
        </div>
        <label [attr.for]="field.key" *ngIf="!field.no_label">
            {{field.label}}
            <ng-container *ngIf="count">({{count}})</ng-container>
            <span *ngIf="field.required">*</span>
        </label>
        <div class="value readonly" *ngIf="field.readonly">
            <div
                class="content"
                (touchrelease)="performAction()"
                *ngIf="format"
            >
                {{format}}
            </div>
            <div
                class="content dim"
                (touchrelease)="performAction()"
                *ngIf="!format"
            >
                No {{field.label}}
            </div>
        </div>
        <ng-container *ngIf="!field.readonly">
            <div
                class="value"
                [class.flex]="field.flex"
                [ngSwitch]="field.control_type"
                [style.max-width]="field.width"
            >
                <!-- TEXT INPUT -->
                <input
                    *ngSwitchCase="'text'"
                    #input
                    [formControlName]="field.key"
                    [id]="field.key"
                    [name]="field.key"
                    [placeholder]="field.label"
                    [type]="field.type"
                />
                <!-- DROPDOWN -->
                <dropdown
                    klass="form"
                    *ngSwitchCase="'dropdown'"
                    [list]="field.options"
                    [formControlName]="field.key"
                    [id]="field.key"
                    [placeholder]="field.label"
                ></dropdown>
                <!-- ACTION FIELD -->
                <div class="select" *ngSwitchCase="'select'">
                    <div
                        class="content"
                        (touchrelease)="performAction()"
                        *ngIf="format"
                    >
                        {{format}}
                    </div>
                    <div
                        class="content dim"
                        (touchrelease)="performAction()"
                        *ngIf="!format"
                    >
                        No {{field.label}}
                    </div>
                </div>
                <!-- FIELD GROUP -->
                <div class="group" *ngSwitchCase="'group'">
                    <ng-container
                        *ngFor="let item of field.children; let i = index"
                    >
                        <div class="spacer" *ngIf="i !== 0"></div>
                        <div class="item">
                            <dynamic-field
                                [field]="item"
                                [form]="form"
                            ></dynamic-field>
                        </div>
                    </ng-container>
                </div>
                <!-- TEXTAREA -->
                <textarea
                    klass="form"
                    *ngSwitchCase="'textarea'"
                    #input
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="4"
                    cdkAutosizeMaxRows="8"
                    [formControlName]="field.key"
                    [id]="field.key"
                    [name]="field.key"
                    [placeholder]="field.label"
                ></textarea>
                <!-- TOGGLE -->
                <ng-container *ngSwitchCase="'toggle'">
                    <toggle
                        klass="form"
                        [type]="field.type || 'android'"
                        [formControlName]="field.key"
                        [id]="field.key"
                        [options]="{ on_text: 'Yes', off_text: 'No' }"
                    ></toggle>
                    <div *ngIf="field.format && format">{{format}}</div>
                </ng-container>
                <!-- SLIDER -->
                <slider
                    klass="form"
                    *ngSwitchCase="'slider'"
                    [formControlName]="field.key"
                    [id]="field.key"
                ></slider>
                <!-- CUSTOM FIELD -->
                <custom-field
                    *ngSwitchCase="'custom'"
                    [field]="field"
                    [form]="form"
                    [cmp]="field.cmp"
                ></custom-field>
            </div>
        </ng-container>
        <div class="state" *ngIf="!field.no_status">
            <i
                [style.opacity]="dirty && value && (isValid || errors) ? 1 : 0"
                class="material-icons"
            >
                {{ errors && dirty ? 'error' : 'done' }}
            </i>
        </div>
    </div>
    <div class="error-message" *ngIf="!!errors && dirty">
        <span *ngIf="errors?.required">{{field.label}} is required</span>
        <span *ngIf="errors.message || !errors?.required"
            >{{errors.message || (field.label + ' is not valid')}}</span
        >
    </div>
</div>
`,
    styles: [`.dynamic-field{-webkit-transition:opacity .2s;transition:opacity .2s}.disabled{opacity:.54;pointer-events:none}.disabled *{pointer-events:none}.field{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin:.25em 0;min-height:2.4em;font-size:1rem;width:100%;overflow:hidden}.field.select .value{border:none}.field.select .value .select *{text-decoration:underline}.field.select .value .select:hover{color:#000}.group>.value{border:none;padding:0}.group>.icon,.group>.state,.group>label{display:none}.custom>.value{-webkit-box-flex:0;-ms-flex:0;flex:0;border:none;padding:0;min-width:55%}@media only screen and (orientation:portrait) and (max-width:450px){.custom>.value{-webkit-box-flex:1;-ms-flex:1;flex:1}}@media only screen and (orientation:landscape) and (max-width:800px){.custom>.value{-webkit-box-flex:1;-ms-flex:1;flex:1}}.custom>.value.flex{-webkit-box-flex:1;-ms-flex:1;flex:1}.dropdown>.value{border:none;padding:0}.toggle>.value{border:none;-webkit-box-flex:0;-ms-flex:0;flex:0;padding:0 .75em}.textarea>.value{border:none}.content{display:inline-block}textarea{width:100%;border:1px solid #ccc;resize:none;font-size:1em;outline:0;padding:.5em}textarea:focus{border-bottom-color:#03a9f4}.value{-webkit-box-flex:1;-ms-flex:1;flex:1;min-height:2em;min-width:5em;border:1px solid #ccc}.value .group{display:-webkit-box;display:-ms-flexbox;display:flex}@media only screen and (orientation:portrait) and (max-width:450px){.value .group{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}}@media only screen and (orientation:landscape) and (max-width:800px){.value .group{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}}.value .item{-webkit-box-flex:1;-ms-flex:1;flex:1}@media only screen and (orientation:portrait) and (max-width:450px){.value .item{-webkit-box-flex:0;-ms-flex:none;flex:none;width:100%}}@media only screen and (orientation:landscape) and (max-width:800px){.value .item{-webkit-box-flex:0;-ms-flex:none;flex:none;width:100%}}.value .select{padding:.5em 0}.value .select div{cursor:pointer}.value.flex{-webkit-box-flex:1;-ms-flex:1;flex:1}dropdown{font-size:1/1.5em}label{font-size:.8em;font-weight:500;min-width:8em;padding:.75em 0;margin-bottom:auto}label span{color:#ff9800}@media only screen and (orientation:portrait) and (max-width:450px){label{min-width:80%;font-size:1em}}@media only screen and (orientation:landscape) and (max-width:800px){label{min-width:80%;font-size:1em}}input{border:none;background:0 0;outline:0;font-size:1em;-webkit-box-flex:1;-ms-flex:1;flex:1;width:100%;padding:.5em}input::-webkit-input-placeholder{color:rgba(0,0,0,.54)}input::-ms-input-placeholder{color:rgba(0,0,0,.54)}input::placeholder{color:rgba(0,0,0,.54)}.icon{height:1em;width:1em;margin:.25em .5em auto .25em;font-size:1.5em;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#03a9f4}.state{color:#4caf50;margin:.5em .25em .5em .5em}.dim{opacity:.65;-webkit-transition:opacity .2s;transition:opacity .2s}.dim:hover{opacity:1}.error .state{color:#f44336}.error .value{border-color:#f44336}.warn .state{color:#ff9800}.warn .value{border-color:#ff9800}.error-message{font-size:.75em;color:#f44336;text-align:right;margin:-.25em 2em .5em}.error-message.warn{color:#ff9800}`]
})
export class DynamicFormFieldComponent extends BaseWidgetComponent implements OnChanges {
    @Input() field: DynamicField<any>;
    @Input() form: FormGroup;

    public ignore: any;

    @ViewChild('input') private input: ElementRef<HTMLInputElement | HTMLTextAreaElement>;

    constructor(private renderer: Renderer2) {
        super();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.form || changes.field) {
            if (this.subs.obs.control) {
                (this.subs.obs.control as Subscription).unsubscribe();
            }
            if (this.form && this.form.controls[this.field.key] && this.field.control_type !== 'select') {
                const field = this.form.controls[this.field.key];
                this.subs.obs.control = field.valueChanges.subscribe(() => this.performAction());
            }
            this.setAttributes();
        }
    }

    get isValid(): boolean {
        const control = this.form && this.form.controls ? this.form.controls[this.field.key] : null;
        return control ? control.valid : false;
    }

    get errors(): { message?: string;[name: string]: boolean | string; } {
        const control = this.form && this.form.controls ? this.form.controls[this.field.key] : null;
        return control ? control.errors : null;
    }

    get count (): string {
        const control = this.form && this.form.controls ? this.form.controls[this.field.key] : null;
        if (control && control.value instanceof Array) {
            return control.value.length.toString();
        }
        return null;
    }

    get dirty(): boolean {
        const control = this.form && this.form.controls ? this.form.controls[this.field.key] : null;
        return control ? control.dirty : true;
    }

    get format(): string {
        const control = this.form && this.form.controls ? this.form.controls[this.field.key] || { value: null } : { value: null };
        return this.field.format ? this.field.format(control.value) : control.value;
    }

    get value() {
        const control = this.form && this.form.controls ? this.form.controls[this.field.key] || { value: null } : { value: null };
        return control.value;
    }

    public performAction() {
        if (this.field.control_type === 'custom') { return; }
        const control = this.form && this.form.controls ? this.form.controls[this.field.key] : null;
        if (this.field.match) {
            const match_control = this.form && this.form.controls ? this.form.controls[this.field.match] : null;
            const validate = (ctrl: AbstractControl) => {
                const error = ctrl.value === control.value;
                return error ? { match: false, message: `${this.field.match}s do not match` } : null;
            }
            match_control.setValidators(this.field.required ? [Validators.required, validate] : [validate]);
        }
        if (control && control.value === this.ignore) {
            return this.timeout('ignore', () => this.ignore = null, 100);
        }
        this.timeout('action', () => {
            if (control && this.field.action && this.field.action instanceof Function) {
                const promise = this.field.action(control.value);
                if (promise && promise.then) {
                    promise.then((new_value) => {
                        this.ignore = new_value;
                        control.setValue(new_value);
                    });
                }
            }
        }, 100);
    }

    private setAttributes(tries: number = 0) {
        if (tries > 20) { return; }
        if (this.field.attributes && this.field.attributes.length > 0) {
            if (this.input && this.input.nativeElement) {
                for (const attr of this.field.attributes) {
                    this.renderer.setAttribute(this.input.nativeElement, attr.name, attr.value);
                }
            } else {
                this.timeout('set_attributes', () => this.setAttributes(++tries));
            }
        }
    }
}
